import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import AlertPOP from "../../routes/AlertPOP";
import { ContextData } from "../../context/Context";
import AwardDialog from "./AwardDialog";
import Instructions from "./Instructions";
import ReadInstrucUploadDoc from "./ReadInstrucUploadDoc";
import DetailsIcon from '@mui/icons-material/Details';

export default function PopupDialog(props) {

  
  const [open, setOpen] = React.useState(false);
  const { RefreshUesFF, setRefreshUesFF } = React.useContext(ContextData);

  const { type, value } = props;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      {/* Dynamic Buttons */}
      {type === "export-excel" && (
        <Button variant="contained" onClick={handleClickOpen}>
          Export to Excel
        </Button>
      )}

      {type === "award" && (
        <Button variant="contained" onClick={handleClickOpen}>
          Award
        </Button>
      )}

      {type === "instruction" && (
        <Button variant="contained" onClick={handleClickOpen}>
          View
        </Button>
      )}

      {type === "set_scholarship" && (
        <Button variant="contained" onClick={handleClickOpen}>
          View
        </Button>
      )}

       {type === "set_loan" && (
        <Button variant="contained" onClick={handleClickOpen}>
          View
        </Button>
      )}

       {type === "readinstructUpload" && (
       
          <p onClick={handleClickOpen} className="flex flex-col cursor-pointer text-red-700 font-extrabold">
                <p><DetailsIcon sx={{ fontSize: "2em" }} /></p>
                <p>Read Instructions</p>
              </p>
        
      )}


      

      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="p-10"
        sx={{ "& .MuiDialog-paper": { width: "600px", maxWidth: "600px" } }} 
      >
        <DialogTitle id="alert-dialog-title">
          {type === "export-excel" && <p> Export To Excel </p>}
          {type === "award" && <p> Award Scholarship </p>}
          {type === "instruction" && <p> Instructions </p>}
        </DialogTitle>
        
        <DialogContent>
          {type === "award" && <AwardDialog />}
          {type === "instruction" && <Instructions value={value} type={type} />}
          {type === "set_scholarship" && <Instructions value={value} type={type} />}
            {type === "set_loan" && <Instructions value={value} type={type} />}
          {type === "readinstructUpload" && <ReadInstrucUploadDoc value={value}  />}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
